import type { Route } from 'next';

import Image from '@/components/image/NextImage';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import { Chevron, ImageWrapper, LeftGroup, Row, RowStatic, Subtitle, TextColumn, Title } from './styles';
import { NarratorRowProps } from './types';

const IMAGE_SIZE = 44;

const NarratorRow = ({ image, title, subtitle, href, ariaLabel }: NarratorRowProps) => {
	const content = (
		<>
			<LeftGroup>
				{image?.url && (
					<ImageWrapper>
						<Image
							fill
							style={{ objectFit: 'cover' }}
							src={formatResizedUrl(image.url, IMAGE_SIZE, IMAGE_SIZE)}
							alt=""
							sizes="44px"
						/>
					</ImageWrapper>
				)}
				<TextColumn>
					<Title>{title}</Title>
					{subtitle && <Subtitle>{subtitle}</Subtitle>}
				</TextColumn>
			</LeftGroup>
			{href && <Chevron />}
		</>
	);

	if (href) {
		return (
			<Row href={href as Route} aria-label={ariaLabel}>
				{content}
			</Row>
		);
	}

	return <RowStatic aria-label={ariaLabel}>{content}</RowStatic>;
};

export default NarratorRow;
